(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["timpani-bundle-draft"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tb-bundle-draft')) {
    customElements.define('tb-bundle-draft', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.selection = new Map();
        this.panel = this.querySelector('.tb73-builder');
        this.opener = this.querySelector('[data-open]');
        try {
          const saved = JSON.parse(sessionStorage.getItem('timpani-bundle-draft-selection'));
          if (Array.isArray(saved)) {
            const ids = new Set(saved.map(String));
            this.querySelectorAll('[data-kit]').forEach(card => {
              if (ids.has(card.dataset.productId) && !card.querySelector('[data-select-kit]').disabled) {
                this.selection.set(card.dataset.productId, {title:card.dataset.title, price:Number(card.dataset.price)});
              }
            });
          }
        } catch { /* No persistent state available: keep the existing empty selection. */ }
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-open]')) {
            event.preventDefault();
            this.open();
          }
          if (event.target.closest('[data-close]')) this.close();
          const button = event.target.closest('[data-select-kit]');
          if (!button || button.disabled) return;
          const card = button.closest('[data-kit]');
          const id = card.dataset.productId;
          if (this.selection.has(id)) this.selection.delete(id);
          else this.selection.set(id, { title:card.dataset.title, price:Number(card.dataset.price) });
          this.update();
        }, {signal:this.abort.signal});
        this.update();
        if (location.hash === this.dataset.url.slice(this.dataset.url.indexOf('#'))) this.open(false);
      }
      disconnectedCallback() { this.abort?.abort(); }
      open(focus = true) {
        this.panel.hidden = false;
        this.opener.setAttribute('aria-expanded', 'true');
        if (focus) this.panel.querySelector('h2').focus({preventScroll:true});
        this.panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block:'start'});
      }
      close() {
        this.panel.hidden = true;
        this.opener.setAttribute('aria-expanded', 'false');
        this.opener.focus();
      }
      money(cents) {
        const format = this.dataset.moneyFormat;
        const token = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
        let decimal = '.', thousands = ',', precision = 2;
        if (token.includes('no_decimals')) precision = 0;
        if (token.includes('comma_separator')) { decimal = ','; thousands = '.'; }
        if (token.includes('space_separator')) thousands = ' ';
        if (token.includes('apostrophe_separator')) thousands = "'";
        const parts = (cents / 100).toFixed(precision).split('.');
        const amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
        const node = document.createElement('span');
        node.innerHTML = format.replace(/\{\{\s*\w+\s*\}\}/, amount);
        return node.textContent;
      }
      update() {
        const count = this.selection.size;
        const rows = [...this.selection.values()];
        const original = rows.reduce((sum, row) => sum + row.price, 0);
        const discount = count >= 3 ? Math.round(original * Number(this.dataset.percent) / 100) : 0;
        this.querySelector('[data-count]').textContent = count === 0 ? this.dataset.zero : (count < 3 ? this.dataset.partial : this.dataset.progress).replace('__COUNT__', count);
        this.querySelector('[data-hint]').textContent = count > 3 ? this.dataset.many : count === 3 ? this.dataset.ready : this.dataset.hint.replace('__COUNT__', 3 - count);
        this.querySelector('.tb73-summary').dataset.eligible = String(count >= 3);
        this.querySelector('[data-savings-highlight]').hidden = count < 3;
        this.querySelectorAll('[data-kit]').forEach(card => {
          const button = card.querySelector('[data-select-kit]');
          if (button.disabled) return;
          const selected = this.selection.has(card.dataset.productId);
          button.setAttribute('aria-pressed', String(selected));
          button.querySelector('[data-selection-label]').textContent = selected ? this.dataset.selected : this.dataset.select;
          button.querySelector('.tb73-check').textContent = selected ? '✓' : '+';
        });
        try { sessionStorage.setItem('timpani-bundle-draft-selection', JSON.stringify([...this.selection.keys()])); } catch { /* Selection still works for this page. */ }
        document.dispatchEvent(new CustomEvent('tb-bundle-selection', {detail:{ids:[...this.selection.keys()]}}));
        this.querySelector('[data-meter]').style.width = Math.min(count / 3 * 100, 100) + '%';
        this.querySelector('[data-empty]').hidden = count > 0;
        const list = this.querySelector('[data-selection]');
        list.replaceChildren(...rows.map(row => {
          const item = document.createElement('li');
          const title = document.createElement('span'); title.textContent = row.title;
          const price = document.createElement('span'); price.textContent = this.money(row.price);
          item.append(title, price); return item;
        }));
        this.querySelector('[data-original]').textContent = this.money(original);
        this.querySelector('[data-total]').textContent = this.money(original - discount);
        this.querySelector('[data-savings]').textContent = this.money(discount);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["timpani-bundle-promotion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tb-bundle-promotion')) {
    customElements.define('tb-bundle-promotion', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-selection-context')) return;
        this.abort?.abort();
        this.abort = new AbortController();
        this.refresh();
        document.addEventListener('tb-bundle-selection', () => this.refresh(), {signal:this.abort.signal});
      }
      disconnectedCallback() { this.abort?.abort(); }
      refresh() {
        let count = 0;
        try {
          const saved = JSON.parse(sessionStorage.getItem('timpani-bundle-draft-selection'));
          if (Array.isArray(saved)) {
            const eligible = new Set(this.dataset.eligibleIds.split('|').filter(Boolean));
            count = new Set(saved.map(String).filter(id => eligible.has(id))).size;
          }
        } catch { /* Storage unavailable: use generic messaging, never infer a selection. */ }
        this.querySelector('[data-bundle-message]').textContent = count >= 3 ? this.dataset.ready : count === 2 ? this.dataset.two : count === 1 ? this.dataset.one : this.dataset.zero;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["timpani-new-drop"] && !Shopify.designMode) return;
  try {
    // One deadline per card; no polling or new animation loop.
if ('customElements' in window && !customElements.get('timpani-new-drop')) {
  customElements.define('timpani-new-drop', class extends HTMLElement {
    constructor() {
      super();
      this.checkExpiry = this.checkExpiry.bind(this);
      this.onVisibility = () => { if (!document.hidden) this.checkExpiry(); };
    }
    connectedCallback() {
      document.addEventListener('visibilitychange', this.onVisibility);
      this.checkExpiry();
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    checkExpiry() {
      clearTimeout(this.expiryTimer);
      const remaining = Number(this.dataset.expires) * 1000 - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) { this.remove(); return; }
      this.expiryTimer = setTimeout(this.checkExpiry, Math.min(remaining, 2147483647));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["timpani-youtube"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('tb-click-media'))customElements.define('tb-click-media',class extends HTMLElement{
 connectedCallback(){if(this.bound)return;this.bound=true;const button=this.querySelector('[data-media-load]');if(!button)return;button.addEventListener('click',()=>this.load());}
 load(){if(this.player)return;const id=this.dataset.id,provider=this.dataset.provider;if(provider==='youtube'&&!/^[A-Za-z0-9_-]{11}$/.test(id))return;if(provider==='spotify'&&!/^[A-Za-z0-9]{22}$/.test(id))return;if(!['youtube','spotify'].includes(provider))return;
 document.querySelectorAll('tb-click-media').forEach(other=>{if(other!==this)other.unload?.();});document.querySelectorAll('audio').forEach(audio=>audio.pause());
 const frame=document.createElement('iframe');frame.title=this.dataset.title||'Media player';frame.referrerPolicy='strict-origin-when-cross-origin';frame.allowFullscreen=true;frame.allow='autoplay; encrypted-media; fullscreen; picture-in-picture';frame.loading='lazy';frame.src=provider==='youtube'?'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&playsinline=1&rel=0':'https://open.spotify.com/embed/track/'+id+'?theme=0';
 const facade=this.querySelector('[data-media-load]');facade.hidden=true;this.querySelector('.tb38-media-editor')?.setAttribute('hidden','');this.append(frame);this.player=frame;
 const close=document.createElement('button');close.type='button';close.className='tb38-media-close';close.textContent='×';close.setAttribute('aria-label','Close player');close.addEventListener('click',()=>{this.unload();facade.focus();});this.append(close);this.closeButton=close;close.focus();}
 unload(){if(!this.player)return;this.player.remove();this.closeButton?.remove();this.player=null;this.querySelector('[data-media-load]').hidden=false;}
 disconnectedCallback(){this.unload();}
});
document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('tb-click-media').forEach(media=>media.unload?.());});

if(!customElements.get('tb-studio-showcase'))customElements.define('tb-studio-showcase',class extends HTMLElement{
 connectedCallback(){this.listener?.abort();this.listener=new AbortController();const fallback=image=>{image.hidden=true;image.closest('.tb78-studio__thumbnail')?.classList.add('tb78-studio__thumbnail--fallback');};this.addEventListener('error',event=>{if(event.target instanceof HTMLImageElement&&event.target.classList.contains('tb78-studio__image'))fallback(event.target);},{capture:true,signal:this.listener.signal});const check=image=>{if(image.naturalWidth===0||(image.hasAttribute('data-youtube-thumbnail')&&image.naturalWidth<=120))fallback(image);};this.addEventListener('load',event=>{if(event.target instanceof HTMLImageElement&&event.target.classList.contains('tb78-studio__image'))check(event.target);},{capture:true,signal:this.listener.signal});this.querySelectorAll('.tb78-studio__image').forEach(image=>{if(image.complete)check(image);});}
 disconnectedCallback(){this.listener?.abort();}
});
  } catch(e) { console.error(e); }
})();

})();
